// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1___a5c8c05e730b143d737","cls2":"AccountMenuButton-cls2__f604175e569bd2ec6b0e AccountMenuButton-cls1___a5c8c05e730b143d737"};